import { useState } from 'react';

const DEFAULT_PUBLISH_ON_CREATE = true;

export const getRecurringRowKey = (recurrentEvent, index) => {
    return recurrentEvent.id || recurrentEvent.order || index + 1;
};

export const seedRecurringPublishSelection = (recurrentEvents = []) => {
    return recurrentEvents.map((recurrentEvent) => ({
        ...recurrentEvent,
        publishOnCreate: typeof recurrentEvent.publishOnCreate === 'boolean'
            ? recurrentEvent.publishOnCreate
            : DEFAULT_PUBLISH_ON_CREATE,
    }));
};

export const toggleRecurringEventInSelection = (selection, key, publishOnCreate) => {
    return (selection || []).map((recurrentEvent, index) => {
        if (getRecurringRowKey(recurrentEvent, index) !== key) {
            return recurrentEvent;
        }
        return {
            ...recurrentEvent,
            publishOnCreate,
        };
    });
};

export const setAllRecurringEventsInSelection = (selection, nextValue) => {
    return (selection || []).map((recurrentEvent) => ({
        ...recurrentEvent,
        publishOnCreate: nextValue,
    }));
};

export const useRecurringPublishSelection = (initialEvents = []) => {
    const [selection, setSelection] = useState(() => seedRecurringPublishSelection(initialEvents));

    const seed = (recurrentEvents) => {
        setSelection(seedRecurringPublishSelection(recurrentEvents));
    };

    const toggleEvent = (key, publishOnCreate) => {
        setSelection((prevSelection) => toggleRecurringEventInSelection(prevSelection, key, publishOnCreate));
    };

    const toggleSelectAll = (nextValue) => {
        setSelection((prevSelection) => setAllRecurringEventsInSelection(prevSelection, nextValue));
    };

    return {
        selection,
        setSelection,
        seed,
        toggleEvent,
        toggleSelectAll,
    };
};
